// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".applyHomePage .container[data-v-4f7beb49]{min-height:calc(100vh - 180px)}.applyHomePage .el-card[data-v-4f7beb49]{width:1200px;margin:0 auto}.applyHomePage .apply[data-v-4f7beb49]{display:flex;justify-content:space-between}.applyHomePage .tableTile[data-v-4f7beb49]{margin-bottom:15px;font-size:24px}", ""]);
// Exports
module.exports = exports;
